import { request } from 'util/request';

export async function getProducts(params?: any) {
  return request('inventory/products', params, 'GET');
}
